
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { listadoTodosSegunRole } from "../../services";

import Swal from "sweetalert2";




const storeApi = (set) => ({

    activeUsuario: null,
    usuarios: [],
    clientes: [],
    operarios: [],
    isLoadingUsuario: false,
    total: 0,


    infoActiveUsuario: async(info) => {
        set({ activeUsuario: info });
    },


    clearListUser: () => {
        set({ usuarios: [] });
    },


    startTotalUsuarios: (total) => {
        set({ total });
    },


    
    startListSegunRol: async(rol) => {
        try {
            const data = await listadoTodosSegunRole(rol);
            set({ usuarios: data });
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },



    startListTodosClinetes: async(rol) => {
        try {
            const data = await listadoTodosSegunRole(rol);
            set({ clientes: data });
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },


    startListTodosOperarios: async(rol) => {
        try {
            const data = await listadoTodosSegunRole(rol);
            set({ operarios: data });
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },





















    startCrearUsuario: async(user) => {
        try {
            // const data = await UsuariosService.createUsuario(user);
            Swal.fire('Exitoso', 'Usuario Creado', 'success');
            set( state => ({ 
                usuarios: [ {}, ...state.usuarios ]
            }));
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },



    startUsuarioPorID: async(id) => {
        try {
            // const data = await UsuariosService.usuarioPorID(id);
            set({ activeUsuario: {} });
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },



    
});






export const useUsuariosStore = create()(
    devtools(
        storeApi
    )
)
